// @ts-nocheck
/* eslint-disable */
import * as types from 'redux/actions/report';
import { arrayMove } from 'react-sortable-hoc';
import { POST_REPORT_SUCCESS } from 'redux/actions/report';
import { getCostCentreLabel } from 'utils/fieldLabel';

const initialState = JSON.stringify({
  showFormModal: false,
  form: {
    title: '',
    description: '',
    isGeneral: 'false',
  },
  filter: {
    startDate: null,
    endDate: null,
    columns: [
      {
        name: 'all',
        options: [{ label: 'All', value: 'all', checked: false }],
      },

      {
        name: 'unsorted',
        options: [
          {
            label: 'Unit',
            value: 'unit',
            checked: false,
          },
          {
            label: 'Contract Sum',
            value: 'contract_sum',
            checked: false,
          },
          {
            label: 'Submitted Claim',
            value: 'submitted_claim',
            checked: false,
          },
          {
            label: 'Assessed Claim',
            value: 'assessed_claim',
            checked: false,
          },
        ],
      },

      {
        name: 'actual',
        options: [
          {
            label: 'Tracked Cost',
            value: 'tracked_cost',
            checked: false,
          },
          {
            label: 'Committed Cost',
            value: 'committed_cost',
            checked: false,
          },
          {
            label: 'Tracked Cost (Committed)',
            value: 'tracked_cost_committed',
            checked: false,
          },
          {
            label: 'Remaining Committed Cost',
            value: 'remaining_committed_cost',
            checked: false,
          },
          {
            label: 'Actual Gross Margin',
            value: 'actual_gross_margin',
            checked: false,
          },
          {
            label: 'Actual Gross Profit',
            value: 'actual_gross_profit',
            checked: false,
          },
          {
            label: 'Actual Quantity Duration',
            value: 'actual_quantity_duration',
            checked: false,
          },
          {
            label: 'Actual Rate',
            value: 'actual_rate',
            checked: false,
          },
          {
            label: 'Tracked Cost to Date',
            value: 'tracked_cost_to_date',
            checked: false,
          },
          {
            label: 'Actual Quantity Duration to Date',
            value: 'actual_quantity_duration_to_date',
            checked: false,
          },
        ],
      },

      {
        name: 'construction',
        options: [
          {
            label: 'Construction Budget Cost',
            value: 'construction_budget_cost',
            checked: false,
          },
          {
            label: 'Construction Budget Claim',
            value: 'construction_budget_claim',
            checked: false,
          },
          {
            label: 'Construction Budget Gross Margin',
            value: 'construction_budget_gross_margin',
            checked: false,
          },
          {
            label: 'Construction Budget Gross Profit',
            value: 'construction_budget_gross_profit',
            checked: false,
          },
          {
            label: 'Construction Budget Quantity Duration',
            value: 'construction_budget_quantity_duration',
            checked: false,
          },
          {
            label: 'Construction Budget To Complete (Dollar)',
            value: 'construction_budget_to_complete_dollar',
            checked: false,
          },
          {
            label: 'Construction Budget To Complete (Quantity * Duration)',
            value: 'construction_budget_to_complete_quantity_duration',
            checked: false,
          },
          {
            label: 'Construction Budget Rate',
            value: 'construction_budget_rate',
            checked: false,
          },
          {
            label: 'Remaining Construction Budget',
            value: 'remaining_construction_budget',
            checked: false,
          },
          {
            label: 'Remaining Construction Budget With Committed Cost',
            value: 'remaining_construction_budget_with_committed_cost',
            checked: false,
          },
        ],
      },

      {
        name: 'estimated',
        options: [
          {
            label: 'Estimated Budget Cost',
            value: 'estimated_budget_cost',
            checked: false,
          },
          {
            label: 'Estimated Budget Gross Margin',
            value: 'estimated_budget_gross_margin',
            checked: false,
          },
          {
            label: 'Estimated Budget Gross Profit',
            value: 'estimated_budget_gross_profit',
            checked: false,
          },
          {
            label: 'Estimated Budget Quantity Duration',
            value: 'estimated_budget_quantity_duration',
            checked: false,
          },
          {
            label: 'Estimated Budget To Complete (Dollar)',
            value: 'estimated_budget_to_complete_dollar',
            checked: false,
          },
          {
            label: 'Estimated Budget To Complete (Quantity * Duration)',
            value: 'estimated_budget_to_complete_quantity_duration',
            checked: false,
          },
          {
            label: 'Estimated Budget Rate',
            value: 'estimated_budget_rate',
            checked: false,
          },
        ],
      },

      {
        name: 'monthly',
        options: [
          {
            label: 'Monthly Construction Budget Cost',
            value: 'monthly_construction_budget_cost',
            checked: false,
          },
          {
            label: 'Monthly Construction Budget Cost Quantity Duration',
            value: 'monthly_construction_budget_cost_quantity_duration',
            checked: false,
          },
          {
            label: 'Monthly Construction Budget Claim',
            value: 'monthly_construction_budget_claim',
            checked: false,
          },
          {
            label: 'Monthly Construction Budget Claim Quantity Duration',
            value: 'monthly_construction_budget_claim_quantity_duration',
            checked: false,
          },
        ],
      },
    ],
    groupBy: [
      {
        name: 'all',
        options: [{ label: 'All', value: 'all', checked: false }],
      },

      {
        name: 'groupBy',
        options: [
          {
            label: 'Task',
            value: 'task',
            checked: false,
          },
          {
            label: 'SubTask',
            value: 'sub_task',
            checked: false,
          },
          {
            label: 'Sub SubTask',
            value: 'sub_sub_task',
            checked: false,
          },
          {
            label: 'Cost Centre',
            value: 'cost_center',
            checked: false,
          },
          {
            label: 'Category',
            value: 'category',
            checked: false,
          },
          {
            label: 'Resource',
            value: 'resource',
            checked: false,
          },
          {
            label: 'Resource Code',
            value: 'resource_code',
            checked: false,
          },
          {
            label: 'Accounting Code',
            value: 'accounting_code',
            checked: false,
          },
          {
            label: 'Segment',
            value: 'segment',
            checked: false,
          },
          {
            label: 'Type',
            value: 'type',
            checked: false,
          },
          {
            label: 'Resource Type',
            value: 'resource_type',
            checked: false,
          },
        ],
      },
    ],
  },
  selectedOptions: {
    columns: [],
    groupBy: [],
  },
  sort_data: {},
  generatedReport: [],
  generatedFilteredReport: [],
  savedReports: [],
  standardReports: [],
  selectedReport: { id: null, type: null },
  isReportPostSuccess: false,
  reportPostData: null,
});

function reportReducer(state = JSON.parse(initialState), action) {
  switch (action.type) {
    case types.OPEN_FORM_MODAL:
      return {
        ...state,
        showFormModal: true,
      };
    case types.CLOSE_FORM_MODAL:
      return {
        ...state,
        showFormModal: false,
      };
    case types.POST_REPORT_SUCCESS:
      return {
        ...state,
        isReportPostSuccess: true,
        reportPostData: action.payload,
        showFormModal: false,
      };

    case types.UPDATE_FORM_FIELD:
      const {
        payload: { name, value },
      } = action;
      return {
        ...state,
        form: {
          ...state.form,
          [name]: value,
        },
      };

    case types.RESET_FORM_FIELD:
      return {
        ...state,
        form: {
          title: '',
          description: '',
          is_general: 'false',
        },
      };

    case types.OPEN_CONFIRMATION_MODAL:
      return {
        ...state,
        showConfirmationModal: true,
        selectedReport: {
          id: action.payload.id,
          type: 'savedReports',
        },
      };

    case types.CLOSE_CONFIRMATION_MODAL:
      return {
        ...state,
        showConfirmationModal: false,
        selectedReport: {
          id: null,
          type: null,
        },
      };

    case types.SELECT_FILTERS:
      return selectFilters(state, action);

    case types.SELECT_FILTERS_WITHOUT_COST_CENTER:
      return selectFiltersExcludeCostCenter(state, action);

    case types.SELECT_FILTER_BY_DATE:
      return selectFilterByDate(state, action);

    case types.REMOVE_SELECTED_FILTER:
      return removeSelectedFilter(state, action);

    case types.GET_REPORT_SUCCESS:
      return {
        ...state,
        savedReports: action.payload,
        standardReports: action.payload.filter((report) => report.template),
      };

    case types.DELETE_REPORT_SUCCESS:
      return {
        ...state,
        savedReports: state.savedReports.filter(
          (report) => report.id !== action.payload.id,
        ),
      };

    case types.RUN_REPORT_SUCCESS:
      const { payload } = action;
      const { data } = payload;
      const hasCostCenterCode = data.some((item) => item.cost_center_code);
      const generatedFilteredReport = hasCostCenterCode
        ? []
        : state.generatedFilteredReport;
      const modifiedData = data.map((item) => {
        const { cost_center_code, ...rest } = item;
        if (cost_center_code) {
          return {
            ...rest,
            cost_center: getCostCentreLabel(
              cost_center_code,
              rest.cost_center,
              rest.cost_center_archived,
            ),
          };
        }
        return rest;
      });
      return {
        ...state,
        generatedReport: {
          ...payload,
          data: modifiedData,
        },
        generatedFilteredReport: [],
      };

    case types.RUN_REPORT_FILTER_SUCCESS:
      const runReportmodifiedData = action.payload.data.map((item) => {
        const { cost_center_code, ...rest } = item;
        if (item.cost_center_code) {
          return {
            ...rest,
            cost_center: getCostCentreLabel(
              item.cost_center_code,
              item.cost_center,
              item.cost_center_archived === '-' ? false : true,
            ),
          };
        }
        return rest;
      });
      return {
        ...state,
        generatedFilteredReport: {
          ...action.payload,
          data: runReportmodifiedData,
        },
      };

    case types.SELECT_REPORT:
      return selectReport(state, action);

    case types.SORT_SELECTED_OPTIONS:
      return sortSelectedOptions(state, action);

    case types.RESET_STATE:
      return JSON.parse(initialState);
    default:
      return state;
  }
}

const selectAllOptions = (state, action) => {
  const {
    payload: { checked, type },
  } = action;

  return {
    ...state,
    filter: {
      ...state.filter,
      [type]: state.filter[type].map((col) => {
        const temp = { ...col };
        col.options.map((option, i) => {
          temp.options[i] = { ...option, checked };
        });
        return temp;
      }),
    },
    selectedOptions: {
      ...state.selectedOptions,
      [type]: checked
        ? [].concat.apply(
            [],
            state.filter[type].map((col) =>
              col.options
                .filter((each) => each.value !== 'all')
                .map((each) => each.value),
            ),
          )
        : [],
    },
  };
};

const selectAllOptionsWithoutCostCenter = (state, action) => {
  const {
    payload: { checked, type },
  } = action;

  return {
    ...state,
    filter: {
      ...state.filter,
      [type]: state?.filter[type]?.map((col) => {
        const temp = { ...col };
        col.options.map((option, i) => {
          temp.options[i] = { ...option, checked };
        });
        return temp;
      }),
    },
    selectedOptions: {
      ...state.selectedOptions,
      [type]: checked
        ? [].concat.apply(
            [],
            state.filter[type].map((col) =>
              col.options
                .filter(
                  (each) =>
                    each.value !== 'all' && each.value !== 'cost_center',
                )
                .map((each) => each.value),
            ),
          )
        : [],
    },
  };
};

const selectOption = (state, action) => {
  const {
    payload: { value, checked, type },
  } = action;

  let optionsCount = 0;
  state.filter[type].map((opt) =>
    opt.options.map((o) => o.value && optionsCount++),
  );

  const selectedOptions = checked
    ? [...state.selectedOptions[type], value]
    : state.selectedOptions[type].filter((opt) => opt !== value);

  const shouldSelectAllOption = optionsCount - 1 === selectedOptions.length;

  return {
    ...state,
    filter: {
      ...state.filter,
      [type]: state.filter[type].map((col) => {
        const temp = { ...col };
        col.options.map((option, i) => {
          if (value === option.value) {
            temp.options[i] = { ...option, checked };
          }
          if (option.value === 'all') {
            // option[i]
            temp.options[i] = { ...option, checked: shouldSelectAllOption };
          }
        });
        return temp;
      }),
    },
    selectedOptions: {
      ...state.selectedOptions,
      [type]: selectedOptions,
    },
  };
};

const selectFilters = (state, action) => {
  const {
    payload: { value },
  } = action;

  if (value.includes('all')) {
    return selectAllOptions(state, action);
  }

  return selectOption(state, action);
};

const selectFiltersExcludeCostCenter = (state, action) => {
  const {
    payload: { value },
  } = action;

  if (value.includes('all')) {
    return selectAllOptionsWithoutCostCenter(state, action);
  }

  return selectOption(state, action);
};

const selectFilterByDate = (state, action) => {
  const {
    payload: { startDate, endDate },
  } = action;
  return {
    ...state,
    filter: {
      ...state.filter,
      startDate,
      endDate,
    },
  };
};

const removeSelectedFilter = (state, action) => {
  const {
    payload: { value, type },
  } = action;

  return {
    ...state,
    filter: {
      ...state.filter,
      [type]: state.filter[type].map((col) => {
        const temp = { ...col };
        col.options.map((option, i) => {
          if (value === option.value || option.value === 'all') {
            temp.options[i] = { ...option, checked: false };
          }
        });
        return temp;
      }),
    },

    selectedOptions: {
      ...state.selectedOptions,
      [type]: state.selectedOptions[type].filter((opt) => opt !== value),
    },
  };
};

const selectReport = (state, action) => {
  const {
    payload: { id, type },
  } = action;
  const selectedReport = state[type]?.find((report) => report.id === id);

  // If report not found, return state unchanged
  if (!selectedReport || !selectedReport.data) {
    return state;
  }

  return {
    ...state,
    filter: {
      columns: state.filter.columns.map((column) => {
        const temp = { ...column };
        column.options.map((option, i) => {
          if (selectedReport?.data?.selected_columns?.includes(option.value)) {
            temp.options[i] = { ...option, checked: true };
          } else {
            temp.options[i] = { ...option, checked: false };
          }
        });
        return temp;
      }),
      groupBy: state.filter.groupBy.map((group) => {
        const temp = { ...group };
        group.options.map((option, i) => {
          if (selectedReport.data?.selected_group_bys?.includes(option.value)) {
            temp.options[i] = { ...option, checked: true };
          } else {
            temp.options[i] = { ...option, checked: false };
          }
        });
        return temp;
      }),
      startDate: selectedReport.data.start_date
        ? new Date(selectedReport.data.start_date)
        : null,
      endDate: selectedReport.data.start_date
        ? new Date(selectedReport.data.end_date)
        : null,
    },
    selectedOptions: {
      columns: selectedReport.data.selected_columns || [],
      groupBy: selectedReport.data.selected_group_bys || [],
    },
    sort_data: selectedReport.sort_data?.data,
    form:
      type === 'savedReports'
        ? {
            title: selectedReport.title,
            description: selectedReport.description,
            is_general: selectedReport.is_general,
          }
        : { title: '', description: '', is_general: 'false' },
    selectedReport: { id: selectedReport.id, type },
  };
};

const sortSelectedOptions = (state, action) => {
  const {
    payload: { oldIndex, newIndex, type },
  } = action;
  return {
    ...state,
    selectedOptions: {
      ...state.selectedOptions,
      [type]: arrayMove(state.selectedOptions[type], oldIndex, newIndex),
    },
  };
};
export default reportReducer;
